export const environment = {
  production: false,
  urlApi: 'https://admin.maltia.cleversecdesarrollo.app:5700/api',
  // urlApi: 'https://localhost:44380/api',
  google: {
    gaApiKey: 'AW-11197307083'
  },
  chatwoot: {
    baseUrl: 'https://chatwoot.cleversec.com.mx',
    websiteToken: 'DZDv5b5i872bCw32mAAMFx1W'
  }
};

// http://localhost:4200/apply-for-credit/upload-ine-front?folio=1131&nip=1QAHX